/* src/app/components/controls/sem-select/sem-select.component.css */
.wg-search .mat-mdc-text-field-wrapper input,
.wg-search mat-form-field.example-full-width input {
  border: none !important;
  border-width: 0 !important;
  border-style: none !important;
  outline: none !important;
  box-shadow: none !important;
}
.wg-search sem-drop-down-select .mat-mdc-form-field-infix {
  position: relative !important;
}
.wg-search sem-drop-down-select .dd-delete {
  position: absolute !important;
  top: 50% !important;
  right: 18px !important;
  left: auto !important;
  transform: translateY(-50%) !important;
  width: 16px !important;
  max-width: 16px !important;
  min-width: 16px !important;
  height: 16px !important;
  flex: 0 0 16px !important;
}
:host:has(.wg-quick-create-trigger) {
  display: flex !important;
  align-items: center;
  gap: 6px;
}
:host:has(.wg-quick-create-trigger) > mat-form-field {
  flex: 1 1 auto;
  min-width: 0;
}
.wg-quick-create-trigger {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  background: transparent;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  color: #2563eb;
  cursor: pointer;
  transition: background-color 120ms ease, border-color 120ms ease;
}
.wg-quick-create-trigger:hover {
  background-color: #eff6ff;
  border-color: #2563eb;
}
.wg-quick-create-trigger:active {
  background-color: #dbeafe;
}
.wg-quick-create-trigger .material-symbols-outlined {
  font-size: 18px;
  line-height: 1;
}
:host(.radio-select-layout) {
  display: block;
  margin-top: 6px;
}
:host(.radio-select-layout) .example-radio-group {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 8px;
}
:host(.radio-select-layout) .example-radio-button {
  display: block;
  max-width: 100%;
}
:host(.radio-select-layout) .example-radio-button .mat-radio-label-content,
:host(.radio-select-layout) .example-radio-button .mdc-label {
  white-space: normal;
}
.sem-tree-select {
  position: relative;
  width: 100%;
}
.sem-tree-select .tree-select-field {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 34px;
  padding: 4px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
}
.sem-tree-select.disabled-field-dd .tree-select-field {
  background: #f1f5f9;
  cursor: default;
}
.sem-tree-select .tree-select-value {
  flex: 1 1 auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #1f2937;
}
.sem-tree-select .tree-select-caret {
  flex: 0 0 auto;
  margin-left: 8px;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid #64748b;
  transition: transform 120ms ease;
}
.sem-tree-select .tree-select-caret.sem-caret-open {
  transform: rotate(180deg);
}
.sem-tree-select .dd-delete {
  right: 26px;
}
.sem-tree-select .tree-select-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1000;
}
.sem-tree-select .tree-select-panel {
  position: absolute;
  z-index: 1001;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  min-width: 240px;
  max-height: 360px;
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  box-shadow: 0 6px 20px rgba(15, 23, 42, 0.18);
  overflow: hidden;
}
.sem-tree-select .tree-select-search {
  padding: 8px;
  border-bottom: 1px solid #e2e8f0;
}
.sem-tree-select .tree-select-search input {
  width: 100%;
  box-sizing: border-box;
  padding: 6px 8px;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  outline: none;
}
.sem-tree-select .tree-select-scroll {
  overflow: auto;
  padding: 4px 0;
}
.sem-tree-select .sem-tree {
  background: transparent;
}
.sem-tree-select .tree-parent-node,
.sem-tree-select .tree-leaf-node {
  display: flex;
  align-items: center;
  min-height: 30px;
  column-gap: 6px;
}
.sem-tree-select .tree-children {
  padding-left: 18px;
}
.sem-tree-select .tree-invisible {
  display: none;
}
.sem-tree-select .tree-toggle,
.sem-tree-select .tree-toggle-spacer {
  flex: 0 0 30px;
  width: 30px;
}
.sem-tree-select .tree-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  min-height: 30px;
  padding: 0;
  border: none;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
}
.sem-tree-select .tree-toggle:hover {
  background: #eff6ff;
}
.sem-tree-select .tree-node-caret {
  position: relative;
  display: inline-block;
  flex: 0 0 16px;
  width: 16px;
  height: 16px;
}
.sem-tree-select .tree-node-caret::before,
.sem-tree-select .tree-node-caret::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #64748b;
}
.sem-tree-select .tree-node-caret::before {
  width: 10px;
  height: 2px;
}
.sem-tree-select .tree-node-caret::after {
  width: 2px;
  height: 10px;
}
.sem-tree-select .tree-node-caret.sem-caret-open::after {
  display: none;
}
.sem-tree-select .tree-toggle:hover .tree-node-caret::before,
.sem-tree-select .tree-toggle:hover .tree-node-caret::after {
  background: #2563eb;
}
.sem-tree-select .tree-node-label {
  flex: 1 1 auto;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  white-space: nowrap;
}
.sem-tree-select .tree-node-label:hover {
  background: #eff6ff;
}
.sem-tree-select .tree-node-label.selected {
  background: #dbeafe;
  font-weight: 600;
}
:host ::ng-deep mat-form-field.sem-select-not-in-list .mdc-text-field,
mat-form-field.sem-select-not-in-list input.autocomplete-input {
  background: #fef2f2 !important;
  border-color: #ef4444 !important;
}
:host ::ng-deep mat-form-field.sem-select-not-in-list .mdc-text-field {
  border-left: 3px solid #ef4444 !important;
}
.sem-select-not-in-list-msg {
  color: #dc2626;
  font-size: 12px;
  line-height: 1.3;
  margin: 2px 0 0 0;
}
/*# sourceMappingURL=sem-select.component.css.map */
